import styled from "../_snowpack/pkg/@emotion/styled.js";
import React, {useEffect, useRef, useState} from "../_snowpack/pkg/react.js";
export default function Collapsible(props) {
  const {children, collapsed} = props;
  const [initiallyCollapsed] = useState(!!collapsed);
  const ref = useRef(null);
  function calcHeight() {
    const childEl = getChildEl();
    const parentEl = getParentEl();
    parentEl.style.maxHeight = "none";
    const styles = getComputedStyle(childEl);
    parentEl.style.maxHeight = "";
    return `calc(${styles.height} + ${styles.marginTop} + ${styles.marginBottom})`;
  }
  function getChildEl() {
    if (!ref.current)
      throw new Error("Ups");
    return ref.current;
  }
  function getParentEl() {
    const el = getChildEl();
    if (!el.parentElement)
      throw new Error("Ups");
    return el.parentElement;
  }
  function open() {
    const height = calcHeight();
    setHeight(height);
  }
  function close() {
    const parentEl = getParentEl();
    parentEl.style.maxHeight = "";
    nextTick(() => setHeight("0"));
  }
  function setHeight(height) {
    const parentEl = getParentEl();
    parentEl.style.setProperty("--max-height", height);
  }
  function nextTick(fn) {
    return requestAnimationFrame(fn);
  }
  useEffect(() => {
    if (collapsed)
      return close();
    open();
  }, [collapsed]);
  return /* @__PURE__ */ React.createElement(Container, {
    initiallyCollapsed
  }, /* @__PURE__ */ React.createElement(Inner, {
    ref
  }, children));
}
const Container = styled.div`
  --max-height: ${({initiallyCollapsed}) => initiallyCollapsed ? "0" : "auto"};
  max-height: var(--max-height);
  overflow: hidden;
  transition: max-height 0.3s;
`;
const Inner = styled.div`
  overflow: hidden;
`;
